var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTelegram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2883 19.3344C16.5298 19.5054 16.841 19.5481 17.1185 19.4431C17.396 19.3374 17.6 19.1004 17.6615 18.8131C18.3133 15.7501 19.8943 7.99736 20.4875 5.21111C20.5325 5.00111 20.4575 4.78286 20.2925 4.64261C20.1275 4.50236 19.8988 4.46186 19.6948 4.53761C16.55 5.70161 6.8653 9.33536 2.9068 10.8001C2.65555 10.8931 2.49205 11.1346 2.5003 11.3994C2.5093 11.6649 2.6878 11.8951 2.94505 11.9724C4.7203 12.5034 7.05055 13.2421 7.05055 13.2421C7.05055 13.2421 8.13955 16.5309 8.7073 18.2034C8.77855 18.4134 8.9428 18.5784 9.15955 18.6354C9.37555 18.6916 9.60655 18.6324 9.7678 18.4801C10.6798 17.6191 12.0898 16.2879 12.0898 16.2879C12.0898 16.2879 14.7688 18.2521 16.2883 19.3344ZM8.0308 12.8266L9.29005 16.9801L9.5698 14.3499C9.5698 14.3499 14.435 9.96161 17.2085 7.46036C17.2895 7.38686 17.3008 7.26386 17.2333 7.17761C17.1665 7.09136 17.0435 7.07111 16.9513 7.12961C13.7368 9.18236 8.0308 12.8266 8.0308 12.8266Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTelegram);
export default __webpack_public_path__ + "static/media/icon-telegram.41838568f148acb2a7b13c588bcb474e.svg";
export { ForwardRef as ReactComponent };